import { KeycloakService } from 'keycloak-angular';
import { HostnameService } from 'src/app/providers/hostname.service';

export function initializeKeycloak(keycloak: KeycloakService, hostname: HostnameService): () => Promise<boolean> {
    return () =>
        keycloak.init({
            config: {
                url: `${hostname.KeycloakAPI}/auth`,
                realm: 'STTTT',
                clientId: 'webapp-nhiemvu',
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false,
            },
            loadUserProfileAtStartUp: true,
        });
}
